import { render } from "./SidebarOri.vue?vue&type=template&id=ca995274&scoped=true"
import script from "./SidebarOri.vue?vue&type=script&lang=js"
export * from "./SidebarOri.vue?vue&type=script&lang=js"

import "./SidebarOri.vue?vue&type=style&index=0&id=ca995274&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\a-okamura\\Documents\\project\\JuchuAppFront\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ca995274"]])

export default __exports__